import { Typography } from "@mui/material";

export default (text: string | number) => {
  return <Typography>{text}</Typography>;
};
